<template>
  <div>
    <div class="container fade show active">
      <div id="stickyBlockStartPoint" />
      <div class="space-1" />

      <div v-if="featuredApis.length > 0" class="container">
        <!-- Title -->
        <div class="row align-items-md-center mb-2 pb-1">
          <div class="col-md-6">
            <h3>{{ $t('M05a-09') }}</h3>
          </div>
          <div class="col-md-6 text-md-right">
            <router-link class="provider-link" :to="{ name: 'provider-info', params: { provider_name: $route.params.provider_name, tab_name: 'api' } }">
              <b>{{ $t('M05A-1-10a') }} <i class="fa fa-angle-right fa-sm ml-1" /></b>
            </router-link>
          </div>
        </div>
        <!-- End Title -->

        <!-- API Carousel -->
        <ApiCarousel
          :key="`featured-apis-${Date.now()}`"
          class="api-carousel-featured"
          :items="featuredApis"
          :apiCardClickHandler="goToApiInfo"
          :fromProvider="true"
          carouselId="api-carousel-featured"
          :loading="loading"
        />
        <!-- End API Carousel -->
      </div>

      <div class="space-1" />
      <div id="stickyBlockEndPoint" />
    </div>
    <!-- ========== Go to Top ========== -->
    <a
      class="js-go-to go-to position-fixed invisible"
      href="#stickyBlockStartPoint"
      data-hs-go-to-options="{
          &quot;targetSelector&quot; : &quot;#logoAndNav&quot;,
          &quot;offsetTop&quot;: 200,
          &quot;position&quot;: {
            &quot;init&quot;: {
              &quot;right&quot;: 30
            },
            &quot;show&quot;: {
              &quot;bottom&quot;: 30
            },
            &quot;hide&quot;: {
              &quot;bottom&quot;: -30
            }
          }
        }"
    >
      <i class="fas fa-angle-up" />
    </a>
    <!-- ========== End Go to Top ========== -->
  </div>
</template>

<script>
const $ = require('jquery')
import ApiCarousel from '@/components/api-carousel'
import HSGoTo from '@/assets/vendor/hs-go-to/src/js/hs-go-to'
// import demoProviderData from '@/data/provider-info.json'
import providerInfoMixin from '@/mixins/provider-info'
import { mapGetters } from 'vuex'

export default {
  name: 'ProviderInfoHome',
  components: {
    ApiCarousel
  },
  mixins: [providerInfoMixin],
  props: {
    featuredApis: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      slickOptions: {
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: 0,
        autoplay: true,
        autoplaySpeed: 7000,
        dots: true
      },
      loaded: false
    }
  },
  computed: {
    ...mapGetters(['userProfile', 'loading'])
  },
  watch: {
    async userProfile() {
      await this.initialise()
    },
    featuredApis: {
      deep: true,
      handler() {}
    }
  },
  async created() {
    await this.initialise()
  },
  mounted() {
    new HSGoTo($('.js-go-to')).init()
  },
  methods: {
    async initialise() {
      this.$store.dispatch('app/setLoading', true)
      if (this.userProfile.id !== '' && this.providerInfo[0]) {
        this.getProvider()
      }
      this.$store.dispatch('app/setLoading', false)
    },
    getProvider() {
      if (this.providerInfo[0] && (this.providerInfo[0].theme_code.toUpperCase() === 'VVIP' || this.providerInfo[0].theme_code.toUpperCase() === 'VIP')) {
        this.slickOptions.prevArrow = '<span class="fa fa-arrow-left slick-arrow slick-arrow-primary-white slick-arrow-left slick-arrow-centered-y shadow-soft rounded-circle ml-n3" />'
        this.slickOptions.nextArrow = '<span class="fa fa-arrow-right slick-arrow slick-arrow-primary-white slick-arrow-right slick-arrow-centered-y shadow-soft rounded-circle mr-n3" />'
      } else {
        this.slickOptions.prevArrow = false
        this.slickOptions.nextArrow = false
      }
    },
    goToApiInfo(item) {
      try {
        this.$router.push({
          name: 'api-info',
          params: {
            provider_name: (item.display_name.toLowerCase().replace(/[^A-Za-z0-9]/g, '-').concat(`-${item.provider_short_id}`)).replace(/\-+/g, '-'),
            api_name: (item.api_name.toLowerCase().replace(/[^A-Za-z0-9]/g, '-').concat(`-${item.api_short_id}`)).replace(/\-+/g, '-'),
            tab_name: 'readme'
          }
        })
      } catch (err) {
        console.log('err in goToApiInfo', err)
      }
    },
    handleInit(event, slick) {
      this.loaded = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~slick-carousel/slick/slick.css';
@import '~slick-carousel/slick/slick-theme.css';
.whitespace {
  white-space: pre-wrap;
}
.bg-img-hero {
  max-width: 1680px;
}
</style>
<style lang="scss">
.api-carousel-featured .slick-track {
  margin-left: 0;
}
.invisible {
  visibility: hidden;
}
</style>
